import type {
  WorkerCommunicationListApiData,
  WorkerCommunicationListApiResponses,
  WorkerMessageCreateApiData,
  WorkerMessageCreateApiResponses,
  WorkerMessagePreviewApiData,
  WorkerMessagePreviewApiResponses
} from '@navio/nsdk';
import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const workerMessageUrls = {
  getWorkerCommunication: dataEndpoint<WorkerCommunicationListApiData, WorkerCommunicationListApiResponses>({
    getUrl: ({ serviceWorkerId, ...queryParams }) =>
      apiUrl(`service-workers/${serviceWorkerId}/communication/`, queryParams)
  }),
  postWorkerMessage: responseEndpoint<WorkerMessageCreateApiData, WorkerMessageCreateApiResponses>({
    getUrl: () => apiUrl('service-worker-messages/'),
    getBody: (data) => data
  }),
  postWorkerMessagePreview: responseEndpoint<WorkerMessagePreviewApiData, WorkerMessagePreviewApiResponses>({
    getUrl: () => apiUrl('service-worker-messages/preview/'),
    getBody: (data) => data
  })
};
